module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "article"
  }, [_c('div', {
    staticClass: "content",
    class: _vm.inFeed ? 'feed-item ' + _vm.orientation : _vm.orientation
  }, [(_vm.published) ? _c('div', {
    staticClass: "published container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 cover-image",
    style: ('background: url(' + (_vm.article.image != null ? _vm.article.image : '/static/placeholders/placeholder-logo.jpg') + ') center center; background-size: cover;')
  }), _vm._v(" "), _c('div', {
    staticClass: "col-8 inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "date col-6"
  }, [_vm._v(_vm._s(_vm.articleDate))]), _vm._v(" "), _c('div', {
    staticClass: "article-type col-6 float-right"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.getIconForArticleType(_vm.article.articleType.name)
  })])]), _vm._v(" "), _c('p', {
    staticClass: "article-type"
  }, [_vm._v(_vm._s(_vm.$t('label.' + _vm.article.articleType.name)))]), _vm._v(" "), (_vm.article.author) ? _c('h4', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.article.author.name + ' ' + _vm.article.author.surname))]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [(_vm.translation.slug !== ' ') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'article',
        params: {
          slug: _vm.translation.slug
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.translation.title))]) : _c('router-link', {
    attrs: {
      "to": {
        name: 'articleById',
        params: {
          id: _vm.article.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.translation.title))])], 1), _vm._v(" "), (_vm.article.articleType.name === 'video') ? _c('div', {
    staticClass: "video"
  }, [_vm._v(_vm._s(_vm.translation.body))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v(_vm._s(_vm.translation.description))]), _vm._v(" "), (_vm.translation.slug !== ' ') ? _c('router-link', {
    staticClass: "btn btn-secondary",
    attrs: {
      "to": {
        name: 'article',
        params: {
          slug: _vm.translation.slug
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.read_all')))]) : _c('router-link', {
    staticClass: "btn btn-secondary",
    attrs: {
      "to": {
        name: 'articleById',
        params: {
          id: _vm.article.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.read_all')))])], 1)])]) : _c('div', {
    staticClass: "unpublished"
  }, [_c('div', {
    staticClass: "subtitle text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.publish_date')))]), _vm._v(" "), _c('div', {
    staticClass: "date text-center"
  }, [_vm._v(_vm._s(_vm.articleDate))]), _vm._v(" "), _c('div', {
    staticClass: "article-type-icon text-center"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.getIconForArticleType(_vm.article.articleType.name),
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "article-type text-center"
  }, [_vm._v(_vm._s(_vm.$t('label.' + _vm.article.articleType.name)))]), _vm._v(" "), _c('h3', {
    staticClass: "title text-center"
  }, [_vm._v("\n        " + _vm._s(_vm.translation.title) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.translation.description))])])]), _vm._v(" "), (_vm.inFeed) ? _c('div', {
    staticClass: "line",
    class: _vm.orientation
  }, [_c('span', {
    staticClass: "theLine"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5decef04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ArticleCard.vue
// module id = 508
// module chunks = 1